import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Portal, Typography } from '@mui/material';

import { MplButton, MplModal, SadFaceAnim } from '@mopla/ui';

interface IProps {
	title: string;
	description?: string;
	actions: ReactNode;
	onClose: VoidFunction;
	testId: string;
}

export const PaymentErrorModal: FC<IProps> = ({
	title,
	description,
	actions,
	onClose,
	testId,
}) => {
	const { t } = useTranslation('payment');

	return (
		<Portal>
			<MplModal
				open
				testId={`${testId}-MplModal`}
				onClose={onClose}
				content={
					<>
						<Box sx={{ mb: '28px' }}>
							<SadFaceAnim />
						</Box>
						<Typography variant="h2">{title}</Typography>
						{description && <Typography>{description}</Typography>}
						{actions}
					</>
				}
				buttons={
					<MplButton
						testId={`${testId}-CancelButton`}
						variant="outlined"
						fullWidth
						onClick={onClose}
					>
						{t('button.cancel')}
					</MplButton>
				}
			/>
		</Portal>
	);
};
